import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import NavBar from '../../components/NavBar';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import Form from './Form';

class EditVideo extends Component {
  static propTypes = {
    token: PropTypes.string,
    id: PropTypes.string,
    loading: PropTypes.bool,
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      hasChanges: false,
      urlSupported: false,
    };
  }
  async submit(validations, file) {
    const { t } = this.props;
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    try {
      await this.form.submit(`/medias/${this.props.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(file),
      });
    } catch (err) {
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false);
    });
    store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: t('Video successfully updated', { ns: TRANSLATION_FILES.translation }) }));
  }
  handleSubmit = (event) => {
    this.form.handleSubmit(event);
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheckSupported = (urlSupported) => {
    if (urlSupported !== this.state.urlSupported) {
      this.setState({ urlSupported });
    }
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Edit video', { ns: TRANSLATION_FILES.translation })}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={t('Save', { ns: TRANSLATION_FILES.translation })}
                onClick={this.handleSubmit}
                disabled={!this.state.hasChanges || (this.state.hasChanges && !this.state.urlSupported)}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, unit) => {
            this.submit(validations, unit);
          }}
          onChange={this.handleOnChange}
          onCheckSupported={this.handleOnCheckSupported}
          loading={this.props.loading}
          media={this.props.data}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(EditVideo);



// WEBPACK FOOTER //
// ./src/containers/Video/Edit.jsx